module.exports = __webpack_public_path__ + "static/media/amka1.0c4df4f6.png";